/* @generated */
/* empty css                                      *//* empty css                              */var xSmallStyling = ["dig-z0miex6_3-8-0", "var(--dig-z0miex1_3-8-0)"];
var smallStyling = ["dig-z0miex7_3-8-0", "var(--dig-z0miex2_3-8-0)"];
var mediumStyling = ["dig-z0miex8_3-8-0", "var(--dig-z0miex3_3-8-0)"];
var largeStyling = ["dig-z0miex9_3-8-0", "var(--dig-z0miex4_3-8-0)"];
var xLargeStyling = ["dig-z0miexa_3-8-0", "var(--dig-z0miex5_3-8-0)"];
var stackStyle = "dig-1wzot9n0_3-8-0";
export {
  largeStyling,
  mediumStyling,
  smallStyling,
  stackStyle,
  xLargeStyling,
  xSmallStyling
};
